export default __webpack_public_path__ + "static/media/icon_payroll.9905d1e6.svg";